import React from "react";

import State from "../../../../containers/State";
import { ReactComponent as StateIcon } from "../../../../img/icons/Limon.svg";
import { CAMPAIGN_2025 } from '../../../../constants';

const stateName = "Limón";
const stateId = "b5jP35ad3DhqVGYuckff";

const Limon = () => {
  return (
    <State stateName={stateName} stateId={stateId} Icon={StateIcon} year="2025" campaign={CAMPAIGN_2025}>
      <StateIcon />
    </State>
  );
};

export default Limon;
